import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'sia-dossier-configuration',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './dossier-configuration.component.html',
  styleUrl: './dossier-configuration.component.scss',
})
export class DossierConfigurationComponent {
  #dialogRef = inject(MatDialogRef<DossierConfigurationComponent>);

  dossierName = signal<string>('');

  onSave() {
    if (this.dossierName().trim()) {
      this.#dialogRef.close(this.dossierName());
    }
  }

  onCancel() {
    this.#dialogRef.close();
  }
}
